// Career Miniapp — ApplyForm formTranslations builder
//
// A useT().t hookra épít: ha a backend translations.system kulcsot kitöltötték,
// azt használjuk; különben a magyar fallback szöveg.
// Egyetlen forrás: a getDefaultFormTranslations a JobDetailView és CvuploadView
// hardcoded objektumát váltja le.
export function buildApplyFormTranslations(t) {
    return {
        // Üres — a parent komponens (JobDetailView/CvuploadView) saját h2-t renderel az
        // `apply_form_heading` / `cvupload_title` translation kulccsal. Az ApplyForm-on
        // belüli formHeading h2 ezzel egyébként duplán jelenne meg.
        formHeading: '',
        fieldRequired: t('apply_field_required', 'Kötelező mező'),
        invalidFormat: t('apply_invalid_format', 'Érvénytelen formátum'),
        cvUploadRequired: t('apply_cv_upload_required', 'CV kötelező'),
        // [B-CVXLSX] a háttér (Jobs.php APPLY_ALLOWED_EXT) listájával azonos engedett formátumok
        fileTypeNotAllowed: (ext) => {
            const allowed = 'pdf, doc, docx, rtf, txt, odt, jpg, jpeg, png';
            const tpl = t('apply_file_type_not_allowed', '');
            if (tpl)
                return tpl.replace('{ext}', ext || '-').replace('{allowed}', allowed);
            return `Nem támogatott fájlformátum (${ext || '-'}), a fájl nem lett csatolva. Engedélyezett formátumok: ${allowed}`;
        },
        fileTypeErrorDismiss: t('apply_file_type_error_dismiss', 'Rendben, folytatom a fájl nélkül'),
        privacyAcceptRequired: t('apply_privacy_required', 'Olvastam és tudomásul veszem'),
        privacyRadioRequired: t('apply_privacy_radio_required', 'Válassz adatvédelmi opciót'),
        duplicateLanguage: t('apply_duplicate_language', 'Duplikált nyelv'),
        uploadCV: t('apply_upload_cv_button', 'Önéletrajz feltöltése'),
        uploadOther: t('apply_upload_other_button', 'További dokumentumok feltöltése'),
        // [CU-869eh3tpk] Nincs '(opcionális)' utótag — a jelöletlen mező opcionális.
        otherDocumentsOptional: t('apply_other_documents_optional', 'További dokumentumok'),
        selectPlaceholder: t('apply_select_placeholder', 'Válassz...'),
        readPrivacyInfo: t('apply_read_privacy_info', 'Olvastam az adatvédelmi tájékoztatót'),
        privacyIntro: t('apply_privacy_intro', 'Kérjük az alábbi tájékoztatót figyelmesen olvassa el, majd a szöveg alatt található jelölőnégyzet segítségével nyilatkozzon adatainak kezeléséről.'),
        addLanguageRow: t('apply_add_language_row', 'Nyelv hozzáadása'),
        addSocialRow: t('apply_add_social_row', 'Profil hozzáadása'),
        socialPlaceholder: t('apply_social_placeholder', 'Profil URL'),
        submit: t('apply_submit', 'Jelentkezem'),
        submitting: t('apply_submitting', 'Küldés...'),
        filesSelected: (count) => {
            const tpl = t('apply_files_selected_template', '');
            if (tpl)
                return tpl.replace('{count}', String(count));
            return `${count} fájl kiválasztva`;
        },
        loading: t('apply_form_loading', 'Betöltés...'),
        errorLoadingForm: t('apply_error_loading_form', 'Hiba a form betöltésénél'),
        submissionError: t('apply_submission_error', 'Küldési hiba'),
        booking: {
            selectDay: t('apply_booking_select_day', 'Válassz napot'),
            selectTime: t('apply_booking_select_time', 'Válassz időpontot'),
            selected: t('apply_booking_selected', 'Választott időpont'),
            duration: t('apply_booking_duration', 'Időtartam'),
            location: t('apply_booking_location', 'Helyszín'),
            online: t('apply_booking_online', 'Online'),
            noSlots: t('apply_booking_no_slots', 'Jelenleg nincs szabad időpont'),
            minutes: t('booking_minutes', 'perc'),
        },
        privacy: {
            // [B-PRIVINTRO] csak fallback: a jelölőnégyzet elsődleges szövege a tenant
            // privacy.texts.newTxt1-e (Fordítások / Adatvédelem), az ApplyForm azt részesíti előnyben
            privacyAccept: { text: t('apply_privacy_accept_text', 'Elfogadom az adatkezelési tájékoztatót') },
            isNewsletter: { text: t('apply_newsletter_text', 'Hírlevélre feliratkozom') },
            isProfile: { text: t('apply_profile_text', 'Profilom megjelenítése') },
            custom1: t('apply_custom1_label', 'Egyedi 1'),
            custom2: t('apply_custom2_label', 'Egyedi 2'),
            custom3: t('apply_custom3_label', 'Egyedi 3'),
            globalRadio: t('apply_global_radio_text', 'Globális adatvédelem'),
            projectRadio: t('apply_project_radio_text', 'Projekt-szintű adatvédelem'),
            readAcknowledgement: t('apply_read_acknowledgement_label', 'Olvastam az adatvédelmi tájékoztatót.'),
        },
    };
}
